/* resources/assets/js/components/pages/dashboard/dashboard.vue */
/* resources/assets/js/institution/features/statisticsmanagement/TestResults.vue */

import { Subscription } from 'Models'

export default {
    methods: {
        initSubscriptions(subscriptions) {
            Subscription.setAll(subscriptions)

            if (subscriptions.length > 0)
                Subscription.setCurrentByProfessionID(
                    subscriptions[0].professionID()
                )
        },

        getSubscription(professionID) {
            return Subscription.getAll().find(
                (s) => s.professionID() === professionID
            )
        },

        filterOutExpired(rawSubscriptions) {
            return rawSubscriptions.map((s) => Subscription.create(s))
        },
    },
}